import { all, debounce } from 'redux-saga/effects'

import { fetchGetFioSaga } from 'store/dadata/sagas/fetch-get-fio'

import * as actions from './dadata.actions'

export default function* () {
  yield all([debounce(1000, actions.FETCH_GET_FIO_REQUEST, fetchGetFioSaga)])
}
